import { DocumentTypes } from "@bbj-types/document/enum";
import { boolean, date, object, string } from "yup";

export const documentSchema = object({
  _id: string().required(),
  name: string().required(),
  url: string().required(),
  date: date().required(),
  typeDoc: string().oneOf(Object.values(DocumentTypes)).required(),
  mimeType: string().required(),
  uploaded: boolean().required(),
  organisation: string().required(),
  isDeletable: boolean().required(),
});
